"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[38493],{

/***/ 38493:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

const SvgLightbulbFilled = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  width: 64,
  height: 64,
  viewBox: "0 0 64 64",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
  cx: 32,
  cy: 32,
  r: 32,
  fill: "#FFE603"
})), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M29.5 41a1 1 0 1 0 0 2v-2Zm5 2a1 1 0 1 0 0-2v2Zm.5-7.674-.43-.903a1 1 0 0 0-.57.903h1Zm-6 0h1a1 1 0 0 0-.57-.903l-.43.903Zm5.848 2.44-.924-.383.924.382ZM29.5 43h5v-2h-5v2Zm5.93-6.77A8 8 0 0 0 40 29h-2a6 6 0 0 1-3.43 5.423l.86 1.807ZM40 29a8 8 0 0 0-8-8v2a6 6 0 0 1 6 6h2Zm-8-8a8 8 0 0 0-8 8h2a6 6 0 0 1 6-6v-2Zm-8 8a8 8 0 0 0 4.57 7.23l.86-1.807A6 6 0 0 1 26 29h-2Zm6 7v-.674h-2V36h2Zm4-.674V36h2v-.674h-2ZM32 40c.452 0 .842 0 1.162-.021.33-.023.66-.072.986-.207l-.765-1.848c-.042.017-.129.044-.357.06-.237.015-.546.016-1.026.016v2Zm2-4c0 .48 0 .79-.017 1.026-.015.228-.042.315-.06.357l1.849.765c.135-.326.184-.656.207-.986.022-.32.021-.71.021-1.162h-2Zm.148 3.772a3 3 0 0 0 1.624-1.624l-1.848-.765a1 1 0 0 1-.541.54l.765 1.849ZM28 36c0 .452 0 .842.021 1.162.023.33.072.66.207.986l1.848-.765c-.017-.042-.044-.129-.06-.357A16.885 16.885 0 0 1 30 36h-2Zm4 2c-.48 0-.79 0-1.026-.017-.228-.015-.315-.042-.357-.06l-.765 1.849c.326.135.656.184.986.207.32.022.71.021 1.162.021v-2Zm-3.772.148a3 3 0 0 0 1.624 1.624l.765-1.848a1 1 0 0 1-.54-.541l-1.849.765Z",
  fill: "#171717"
})));
/* harmony default export */ __webpack_exports__["default"] = (SvgLightbulbFilled);

/***/ })

}]);